import { Checkbox } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { ColorApi, ColorGridDto, ColorSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { useGlobalData } from "../../../../contexts";

export interface IColorListPageProps {}

export const ColorListPage: React.FunctionComponent<IColorListPageProps> = (props) => {
  const api = useApiService(ColorApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: ColorGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => history.push(`${ERoutes.color}/${row.colorId}/detail/view`)} />
            <EditButton minimal={true} onClick={() => history.push(`${ERoutes.color}/${row.colorId}/detail/edit`)} />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.IsMerle),
        fieldName: "isMerle",
        alignment: "center",
        render: (row: ColorGridDto) => <Checkbox checked={row.isMerle} disabled />,
      },
      {
        header: () => t(ETLCodes.Official),
        fieldName: "official",
        headerAlignment: "center",
        alignment: "center",
        render: (row: ColorGridDto) => <Checkbox checked={row.official} disabled />,
      },
      {
        header: () => t(ETLCodes.ColorCode),
        fieldName: "code",
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.color}/0/detail/edit`);
  }, [history]);

  const searchColorFunction = React.useCallback(
    (sObj) => {
      //api.abortPendingRequest();
      return api.baseSearch(ColorSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId }));
    },
    [api, currentLanguage.languageId]
  );
  const exportFunction = React.useCallback(
    (sObj) => api.exportXlsFile(ColorSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  const searchColorCriteriasFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={searchColorCriteriasFunction}
      searchFunction={searchColorFunction}
      exportFunction={exportFunction}
      addFunc={addItemFunction}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Colors) }]}
    />
  );
};
